import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import React from "react";

export const VoterApolloClient = React.createContext(
  {} as ApolloClient<NormalizedCacheObject>
);
